<template>
  <span class="brand-icon">
    <svg :width="size" :height="size" viewBox="0 0 96 96" aria-hidden="true">
      <defs>
        <linearGradient :id="gid" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stop-color="#5b73c4" />
          <stop offset="1" stop-color="#33489a" />
        </linearGradient>
      </defs>
      <rect x="4" y="4" width="88" height="88" rx="24" :fill="`url(#${gid})`" />
      <path d="M4 28 Q4 4 28 4 H68 Q92 4 92 28" fill="#fff" fill-opacity="0.1" />
      <text
        class="ic-pulse"
        x="48"
        y="69"
        font-size="62"
        font-weight="800"
        fill="#c19d65"
        text-anchor="middle"
        font-family="'Segoe UI', system-ui, sans-serif"
      >S</text>
    </svg>
  </span>
</template>

<script>
// Logo de marca de SmartHub (monograma "S" dorado sobre squircle azul). Se usa
// dentro de las sub-apps (botón "Volver al Hub"). La "S" pulsa al pasar el cursor;
// respeta prefers-reduced-motion.
export default {
  name: 'SmartHubLogo',
  props: { size: { type: [Number, String], default: 30 } },
  data() {
    return { gid: 'sh-' + Math.random().toString(36).slice(2, 8) }
  },
}
</script>

<style scoped>
.brand-icon { display: inline-flex; line-height: 0; }
.brand-icon svg { filter: drop-shadow(0 3px 7px rgba(23, 35, 57, 0.22)); }
.ic-pulse { transform-box: fill-box; transform-origin: center; }
.brand-icon:hover .ic-pulse { animation: sh-pulse 1.2s ease-in-out infinite; }
@keyframes sh-pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.12); }
}
@media (prefers-reduced-motion: reduce) {
  .brand-icon:hover .ic-pulse { animation: none; }
}
</style>
